import { gql } from '@apollo/client'

export const SETUP_TEST_SESSION_PAYMENT = gql`
  mutation SetupTestSessionPayment($id: ID!) {
    setupTestSessionPayment(id: $id)
  }
`
